import React, { useState } from 'react';
import './PaymentMethod.css';
import { assets } from '../assets/assets';
import { images } from '../images/images';
import { useNavigate } from 'react-router-dom';

export default function PaymentMethod({ setShowPayment, orderData }) {
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    const onSubmitHandler = async (event) => {
        event.preventDefault();
        navigate('/undefined');
    };

    return (
        <>
            <div className="payment-popup">
                <form onSubmit={onSubmitHandler} className="payment-popup-container">
                    <div className="payment-left">
                        <div className="payment-popup-title">
                            <h2>E-Wallet</h2>
                            <img onClick={() => setShowPayment(false)} src={assets.cross_icon} alt="" />
                        </div>
                        <div className="payment-popup-inputs">
                            <h2>Scan QR Code</h2>
                            <img src={images.qrcode} alt="QR Code" />
                        </div>
                    </div>
                    <div className="payment-right">
                        <div className="add-img-upload flex-col">
                            <p>Upload Image</p>
                            <label htmlFor="image">
                                <img src={image ? URL.createObjectURL(image) : images.upload_area} alt="" />
                            </label>
                            <input required onChange={(e) => setImage(e.target.files[0])} type="file" id="image" hidden />
                            <button type="submit">Continue</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
